$(document).on("tqht_mansite_char rendered", {}, function (event, uniqueId) {
  var $this = $("#" + uniqueId);

  // console.log(event);
  // console.log(uniqueId);
  // console.log($this);
  function initWeaponThumbs() {
  $(".weapon-group").each(function () {
    const group = $(this);
    const id = group.data("id");

    const thumbSelector = `.thumbs-${id}`;
    const swiperSelector = `.swiper-${id}`;

    const weaponThumbs = new Swiper(thumbSelector, {
      slidesPerView: 4,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      direction: window.innerWidth < 950 ? "horizontal" : "vertical",
      on: {
        resize: function () {
          this.changeDirection(window.innerWidth < 950 ? "horizontal" : "vertical");
        },
      },
    });

    const weaponSwiper = new Swiper(swiperSelector, {
      effect: "fade",
      fadeEffect: { crossFade: true },
      spaceBetween: 10,
      navigation: {
        nextEl: group.find(".nextThumb")[0],
        prevEl: group.find(".prevThumb")[0],
      },
      thumbs: { swiper: weaponThumbs },
      on: {
        slideChange: function () {
          const activeIndex = this.activeIndex;
          const visibleThumbs = weaponThumbs.params.slidesPerView;
          const currentThumbIndex = weaponThumbs.activeIndex;

          if (
            activeIndex < currentThumbIndex ||
            activeIndex >= currentThumbIndex + visibleThumbs
          ) {
            weaponThumbs.slideTo(activeIndex - Math.floor(visibleThumbs / 2));
          }
        },
      },
    });
  });
}
initWeaponThumbs();
// $(".tabs").each(function () {
//   const tabGroup = $(this);

//   // Chỉ lắng nghe sự kiện click trong tabGroup hiện tại
//   tabGroup.children(".tab_head").find("ul li").on("click", function () {
//     const index = $(this).index();

//     // Active tab head
//     $(this).addClass("active").siblings().removeClass("active");

//     // Active tab content tương ứng (chỉ ở cấp con trực tiếp)
//     tabGroup.children(".tab_content").children(".tab_content--item")
//       .removeClass("active")
//       .eq(index)
//       .addClass("active");
//   });
// });
$(".tabs").each(function () {
  const tabGroup = $(this);

  tabGroup.children(".tab_head").find("ul li").on("click", function () {
    const index = $(this).index();

    // Active tab head
    $(this).addClass("active").siblings().removeClass("active");

    const items = tabGroup.children(".tab_content").children(".tab_content--item");
    items.removeClass("active").find(".thumb_content").removeClass("slide-in");

    // Ẩn prev/next khi chuyển tab
    items.find(".prevThumb, .nextThumb").removeClass("show");

    const activeItem = items.eq(index).addClass("active");

    // Trigger animation
    const thumbContent = activeItem.find(".thumb_content").addClass("slide-in");

    // Sau khi animation kết thúc thì hiện prev/next
    setTimeout(function () {
      activeItem.find(".prevThumb, .nextThumb").addClass("show");
    }, 500); // Thời gian khớp với thời gian animation CSS
  });
});


$(".readmore").click(function (e) {
  e.stopPropagation(); // Ngăn click lan ra ngoài
  const id = $(this).data("id");
  $(".gr_chitiet, .thumb_content").removeClass("active"); // remove hết trước
  $(".gr_chitiet[data-id='" + id + "'], .thumb_content").addClass("active");
});

// Ngăn sự kiện click bên trong gr_chitiet lan ra ngoài
$(".gr_chitiet").click(function (e) {
  e.stopPropagation();
});

// Click bất kỳ chỗ nào trên document ngoài gr_chitiet thì remove active
$(document).click(function () {
  $(".gr_chitiet, .thumb_content").removeClass("active");
});

});
